module.exports = __webpack_public_path__ + "static/media/automotive.ab6c59b6.svg";